var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatWeDo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.43,
    height: 23.832,
    viewBox: "0 0 26.43 23.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-project-architect-4726785",
    transform: "translate(-1 -4.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M27.43,17.907a2.077,2.077,0,1,0-4.154,0v1.47H5.154v-1.47A2.012,2.012,0,0,0,3.077,15.83,2.012,2.012,0,0,0,1,17.907V32.233H1v.111a2.493,2.493,0,0,0,2.49,2.49H24.873a2.554,2.554,0,0,0,2.552-2.552v-.05h0V17.907Zm-3.328,0a1.251,1.251,0,0,1,2.5,0V30.544a2.216,2.216,0,0,0-2.5,0Zm-22.275,0a1.184,1.184,0,0,1,1.251-1.251,1.187,1.187,0,0,1,1.251,1.251V30.544a2.187,2.187,0,0,0-1.251-.388,2.156,2.156,0,0,0-1.251.388ZM26.6,32.282a1.728,1.728,0,0,1-1.726,1.726H3.49a1.667,1.667,0,0,1-1.664-1.664v-.111a1.187,1.187,0,0,1,1.251-1.251,1.187,1.187,0,0,1,1.251,1.251.413.413,0,0,0,.826,0V20.2H23.271v12.03a.413.413,0,0,0,.826,0,1.251,1.251,0,1,1,2.5,0h0v.05Z",
    transform: "translate(0 -6.862)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M30.759,29.24h-2.3a.413.413,0,0,0,0,.826h1.891V32.92H24.081V30.066H25.91a.413.413,0,0,0,0-.826H20.7a.414.414,0,0,0-.413.413V39.676a.414.414,0,0,0,.413.413H30.755a.414.414,0,0,0,.413-.413V29.653A.408.408,0,0,0,30.759,29.24Zm-7.5.826v3.267a.414.414,0,0,0,.413.413h1.2v2.882H21.12V30.066Zm-2.139,7.388h4.163a.414.414,0,0,0,.413-.413v-3.3h4.65v2.734H28a.414.414,0,0,0-.413.413v2.37H21.116Zm7.3,1.809V37.305h1.929v1.957Z",
    transform: "translate(-11.324 -14.735)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M7.529,6.973,11.4,9.021c.008,0,.017,0,.025.008a.059.059,0,0,0,.025.008.429.429,0,0,0,.145.029H27.186a1.345,1.345,0,0,0,1.342-1.342V5.482A1.345,1.345,0,0,0,27.186,4.14H11.592s-.008,0-.012,0a.5.5,0,0,0-.132.025l-.029.012c-.008,0-.017,0-.021.008L7.529,6.242a.414.414,0,0,0-.219.363A.426.426,0,0,0,7.529,6.973Zm4.477.045H24.1V8.241h-12.1ZM27.7,5.482V7.729a.516.516,0,0,1-.516.516H24.927V4.97h2.259A.516.516,0,0,1,27.7,5.482ZM24.1,4.97V6.192h-12.1V4.97Zm-12.922.273v2.73L8.607,6.61Z",
    transform: "translate(-3.704 0)",
    fill: "#1c1c74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDo2);
export default __webpack_public_path__ + "static/media/whatWeDo2.f934b3d457e9308efe69eb3b955a58d2.svg";
export { ForwardRef as ReactComponent };